module.exports = __webpack_public_path__ + "img/unrevealed3.102b1261.svg";